import { render } from "./AddAssetViewPreview.vue?vue&type=template&id=dd7ffff4"
import script from "./AddAssetViewPreview.ts?vue&type=script&lang=js"
export * from "./AddAssetViewPreview.ts?vue&type=script&lang=js"

import "./AddAssetViewPreview.vue?vue&type=style&index=0&id=dd7ffff4&lang=css"

import exportComponent from "/home/gitlab-runner/builds/snj4qLhS/0/titletool/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__